import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Site search. Submitting navigates to /blogs?q=… rather than filtering in
 * place, so a search result is a shareable, linkable URL — which is also what
 * the SearchAction in the WebSite JSON-LD promises Google.
 *
 * It is a real <form> with a real submit, so it works before hydration.
 */
function SearchBox({ initialQuery = '', id = 'site-search', className = '' }) {
  const navigate = useNavigate();
  const [value, setValue] = useState(initialQuery);

  // Keep in sync when the URL changes underneath us (back button, chip click).
  useEffect(() => setValue(initialQuery), [initialQuery]);

  const submit = (e) => {
    e.preventDefault();
    const q = value.trim();
    navigate(q ? `/blogs?q=${encodeURIComponent(q)}` : '/blogs');
  };

  return (
    <form className={`search-box ${className}`} role="search" action="/blogs" onSubmit={submit}>
      {/* "titles", not "articles": the backend matches the title only — it does
          not search excerpt, body or tags. Promising full-text search here would
          make an empty result look like a bug. */}
      <label className="sr-only" htmlFor={id}>
        Search article titles
      </label>
      <svg className="search-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="10.5" cy="10.5" r="6.5" />
        <path d="M15.5 15.5 21 21" strokeLinecap="round" />
      </svg>
      <input
        id={id}
        name="q"
        type="search"
        placeholder="Search titles…"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        autoComplete="off"
      />
      {value && (
        <button
          type="button"
          className="search-clear"
          aria-label="Clear search"
          onClick={() => {
            setValue('');
            navigate('/blogs');
          }}
        >
          ×
        </button>
      )}
    </form>
  );
}

export default SearchBox;
